<template>
  <div class="dashbaord-section">
    <div class="mx-4 mb-3">
      <v-row class="mb-4">
        <v-col lg="6" md="12" cols="12">
          <v-card class="d-flex flex-column" height="100%">
            <v-card-title class="xlg--text fontweight400 pt-6">
              Web Scraping API</v-card-title
            >
            <v-card-text
              class="text--primary flex-grow-1 d-flex flex-column"
              v-if="!!subscription && !!subscription.plan"
              height="100%"
            >
              <div>
              <p class="fontlight--text xs--text">
                Current plan:
                <router-link
                  class="text-decoration router-link"
                  to="/subscriptions"
                  ><b>{{ subscription.plan.name }}</b></router-link
                >
              </p>
              <p class="fontlight--text xs--text">
                Start date:
                <b>{{ getUTCDateString(subscription.start_time) }}</b>
              </p>
              <p class="fontlight--text xs--text">
                Renewal date:
                <b>{{ getUTCDateString(subscription.end_time) }}</b>
              </p>
                <p class="fontlight--text xs--text">
                  Restart the subscription when running out of API credits:
                  <router-link
                      class="text-decoration router-link"
                      to="/webscrapingapi"
                  ><b>{{ api_renew_status ? 'Enabled' : 'Disabled' }}</b></router-link>
                </p>
              <p class="fontlight--text xs--text">
                API token:
                <b>{{ api_token }}</b>
              </p>
              </div>
              <v-spacer></v-spacer>
              <div>
              <v-progress-linear
                  color="primary"
                  height="20"
                  :value="usageValue"
                  striped
              >
                <template v-slot:default="{ value }">
                  <strong>{{ Math.round(value * 100) / 100 }}%</strong>
                </template>
              </v-progress-linear>
              <p class="fontlight--text xs--text">
                You have consumed
                <b>{{
                    (subscription.total_credits -
                  subscription.remained_credits).toLocaleString()
                }}</b>
                from <b>{{ subscription.total_credits.toLocaleString() }}</b> available API
                credits
              </p>
              <p
                class="fontlight--text xs--text"
                v-if="subscription.remained_credits === 0"
              >
                You've run out of API credits in the current subscription.
                Please, visit
                <router-link
                  class="text-decoration router-link"
                  to="/subscriptions"
                  >Subscriptions</router-link
                >
                to Upgrade your plan or
                <a
                  class="text-decoration router-link"
                  href="mailto:support@scrapingant.com"
                  >Contact Us</a
                >
                to discuss a custom plan.
              </p>
              </div>
            </v-card-text>
            <v-card-text v-else>
              <p class="fontlight--text xs--text">
                No active subscription. Please,
                <a class="text-decoration router-link" @click="reload"
                  >reload</a
                >
                page or try again later.
              </p>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col lg="6" md="12" cols="12">
          <v-card class="d-flex flex-column" height="100%">
            <v-card-title class="xlg--text fontweight400 pt-6">
              Residential proxies</v-card-title
            >
            <v-card-text
                class="text--primary"
                v-if="!!residential_subscription && !!residential_subscription.plan_name"
            >
              <p class="fontlight--text xs--text">
                Current plan:
                <router-link
                    class="text-decoration router-link"
                    to="/subscriptions?tab=residential"
                ><b>{{ residential_subscription.plan_name }}</b></router-link
                >
              </p>
              <p class="fontlight--text xs--text">
                Start date:
                <b>{{ parseDate(residential_subscription.start_date) }}</b>
              </p>
              <p class="fontlight--text xs--text">
                {{ residential_subscription.recurring ? 'Renewal date:' : 'End date:'}}
                <b>{{ parseDate(residential_subscription.end_date) }}</b>
              </p>
              <p class="fontlight--text xs--text">
                Username:
                <b>{{ residential_credentials.proxy_username }}</b>
              </p>
              <p class="fontlight--text xs--text">
                Password:
                <b>{{ residential_credentials.proxy_secret }}</b>
              </p>
              <v-progress-linear
                  color="primary"
                  height="20"
                  :value="residentialUsageValue"
                  striped
              >
                <template v-slot:default="{ value }">
                  <strong>{{ Math.round(value * 100) / 100 }}%</strong>
                </template>
              </v-progress-linear>
              <p class="fontlight--text xs--text">
                You have consumed
                <b>{{ residential_subscription.traffic_used_gb.toLocaleString() }}</b>
                from <b>{{ residential_subscription.traffic_limit_gb.toLocaleString() }}</b> available GBs
              </p>
              <p
                  class="fontlight--text xs--text"
                  v-if="residential_subscription.traffic_used_gb >= residential_subscription.traffic_limit_gb"
              >
                You've run out of traffic in the current subscription.
                Please, visit
                <router-link
                    class="text-decoration router-link"
                    to="/subscriptions?tab=residential"
                >Subscriptions</router-link
                >
                to Upgrade your plan or
                <a
                    class="text-decoration router-link"
                    href="mailto:support@scrapingant.com"
                >Contact Us</a
                >
                to discuss a custom plan.
              </p>
            </v-card-text>
            <v-card-text v-else>
              <p class="fontlight--text xs--text">
                No active subscription. Please
                <router-link
                    :to="{ path: '/subscriptions?tab=residential' }" class="text-decoration router-link"
                >subscribe</router-link>
                to residential proxies subscription.
              </p>
            </v-card-text>
            <v-spacer></v-spacer>
          </v-card>
        </v-col>
        <v-col lg="6" md="12" cols="12">
          <v-card class="d-flex flex-column" height="100%">
            <v-card-title class="xlg--text fontweight400 pt-6">
              Datacenter proxies</v-card-title
            >
            <v-card-text
                class="text--primary"
                v-if="!!datacenter_subscription && !!datacenter_subscription.plan_name"
            >
              <p class="fontlight--text xs--text">
                Current plan:
                <router-link
                    class="text-decoration router-link"
                    to="/subscriptions?tab=datacenter"
                ><b>{{ datacenter_subscription.plan_name }}</b></router-link
                >
              </p>
              <p class="fontlight--text xs--text">
                Start date:
                <b>{{ parseDate(datacenter_subscription.start_date) }}</b>
              </p>
              <p class="fontlight--text xs--text">
                {{ datacenter_subscription.recurring ? 'Renewal date:' : 'End date:'}}
                <b>{{ parseDate(datacenter_subscription.end_date) }}</b>
              </p>
              <p class="fontlight--text xs--text">
                Username:
                <b>{{ datacenter_credentials.proxy_username }}</b>
              </p>
              <p class="fontlight--text xs--text">
                Password:
                <b>{{ datacenter_credentials.proxy_secret }}</b>
              </p>
              <v-progress-linear
                  color="primary"
                  height="20"
                  :value="datacenterUsageValue"
                  striped
              >
                <template v-slot:default="{ value }">
                  <strong>{{ Math.round(value * 100) / 100 }}%</strong>
                </template>
              </v-progress-linear>
              <p class="fontlight--text xs--text">
                You have consumed
                <b>{{ datacenter_subscription.traffic_used_gb.toLocaleString() }}</b>
                from <b>{{ datacenter_subscription.traffic_limit_gb.toLocaleString() }}</b> available GBs
              </p>
              <p
                  class="fontlight--text xs--text"
                  v-if="datacenter_subscription.traffic_used_gb >= datacenter_subscription.traffic_limit_gb"
              >
                You've run out of traffic in the current subscription.
                Please, visit
                <router-link
                    class="text-decoration router-link"
                    to="/subscriptions?tab=datacenter"
                >Subscriptions</router-link
                >
                to Upgrade your plan or
                <a
                    class="text-decoration router-link"
                    href="mailto:support@scrapingant.com"
                >Contact Us</a
                >
                to discuss a custom plan.
              </p>
            </v-card-text>
            <v-card-text v-else>
              <p class="fontlight--text xs--text">
                No active subscription. Please
                <router-link
                    :to="{ path: '/subscriptions?tab=datacenter' }" class="text-decoration router-link"
                >subscribe</router-link>
                to datacenter proxies subscription.
              </p>
            </v-card-text>
            <v-spacer></v-spacer>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div class="mx-4 mb-4">
      <v-row>
        <v-col cols="12" lg="4" md="12">
          <v-card>
            <v-card-title> <div class="md-title">
              <v-icon color="primary">mdi-robot</v-icon>
              Web Scraping API UI helper
            </div></v-card-title>
            <v-card-text>
               <p>Explore the full web scraping API potential with visual request generator.</p>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn
                  text
                  color="primary"
                  to="/webscrapingapi"
              >
                Make request
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" lg="4" md="12">
          <v-card>
            <v-card-title> <div class="md-title">
              <v-icon color="primary">mdi-account-network</v-icon>
              Fastest Residential Proxies
            </div></v-card-title>
            <v-card-text>
              <p>Unlimited concurrency residential proxies <b>without use case limitations!</b></p>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn
                  text
                  color="primary"
                  to="/residential"
              >
                Setup proxy
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" lg="4" md="12">
          <v-card>
            <v-card-title> <div class="md-title">
              <v-icon color="primary">mdi-server-network</v-icon>
              Affordable Datacenter Proxies
            </div></v-card-title>
            <v-card-text>
              <p>Clever-engineered proxy pool for your day-to-day usage!</p>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn
                  text
                  color="primary"
                  to="/datacenter"
              >
                Start using
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div class="mx-4 mb-4">
      <v-row>
        <v-col cols="12" lg="6" md="12">
          <v-card>
            <v-card-title> <div class="md-title">Web Scraping API usage</div></v-card-title>
            <v-card-text>
              <usage-chart
                  :start-date="getUTCDateString(subscription.start_time)"
                  :chart-data="chartdata"
              />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" lg="6" md="12">
          <v-card>
            <v-card-title> <div class="md-title">Residential proxies usage</div></v-card-title>
            <v-card-text>
              <usage-chart
                  :start-date="parseDate(residential_subscription.start_date)"
                  :chart-data="residential_chartdata"
              />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" lg="6" md="12">
          <v-card>
            <v-card-title> <div class="md-title">Datacenter proxies usage</div></v-card-title>
            <v-card-text>
              <usage-chart
                  :start-date="parseDate(datacenter_subscription.start_date)"
                  :chart-data="datacenter_chartdata"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div class="loading-overlay" v-if="loading">
      <v-progress-circular
        :size="50"
        :width="2"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import UsageChart from "../views/UsageChart";
import getDateUTCString from "@/utils/date_utils";

export default {
  name: "Dashboard",
  components: {UsageChart},
  data() {
    return {
      api_token: "",
      subscription: {},
      api_renew_status: false,
      residential_subscription: {},
      datacenter_subscription: {},
      residential_credentials: {},
      datacenter_credentials: {},
      chartdata: {
        labels: [],
        datasets: [
          {
            label: "API credits usage",
            lineTension: 0.2,
            borderWidth: 2,
            pointRadius: 2,
            backgroundColor: "#FFFFFF00",
            borderColor: "#E2782F",
            pointBorderColor: "#E2782F",
            pointBackgroundColor: "#E2782F",
            data: [],
          },
        ],
      },
      residential_chartdata: {
        labels: [],
        datasets: [
          {
            label: "MBs used",
            lineTension: 0.2,
            borderWidth: 2,
            pointRadius: 2,
            backgroundColor: "#FFFFFF00",
            borderColor: "#E2782F",
            pointBorderColor: "#E2782F",
            pointBackgroundColor: "#E2782F",
            data: [],
          },
        ],
      },
      datacenter_chartdata: {
        labels: [],
        datasets: [
          {
            label: "MBs used",
            lineTension: 0.2,
            borderWidth: 2,
            pointRadius: 2,
            backgroundColor: "#FFFFFF00",
            borderColor: "#E2782F",
            pointBorderColor: "#E2782F",
            pointBackgroundColor: "#E2782F",
            data: [],
          },
        ],
      },
      loading: false,
      result_loading: false,
      usage_grapph_loading: false,
      residential_usage_grapph_loading: false,
      datacenter_usage_grapph_loading: false,
    };
  },
  computed: {
    usageValue() {
        return this.subscription
            ? (1 - parseFloat(this.subscription.remained_credits) / parseFloat(this.subscription.total_credits)) * 100
            : 0;
    },
    residentialUsageValue() {
        return this.residential_subscription
            ? this.residential_subscription.traffic_used_gb / this.residential_subscription.traffic_limit_gb * 100
            : 0;
    },
    datacenterUsageValue() {
      return this.datacenter_subscription
          ? this.datacenter_subscription.traffic_used_gb / this.datacenter_subscription.traffic_limit_gb * 100
          : 0;
    },
  },
  methods: {
    getToken() {
      return this.$store.dispatch("dashboard/getApiToken").then(
          (res) => {
            this.api_token = res.data.token;
          },
          (err) => {
            console.log(err);
          }
      );
    },

    getUsageGraph() {
      this.usage_grapph_loading = true;
      return this.$store.dispatch("dashboard/getUsageGraph").then((res) => {
        this.usage_grapph_loading = false;
        const newChartData = Object.assign({}, this.chartdata);
        newChartData.labels = res.data.labels;
        newChartData.datasets[0] = {
          label: 'API credits usage',
          lineTension: 0.2,
          borderWidth: 2,
          pointRadius: 2,
          backgroundColor: '#FFFFFF00',
          borderColor: '#E2782F',
          pointBorderColor: '#E2782F',
          pointBackgroundColor: '#E2782F',
          data: res.data.data
        };
        if (res.data.detailed_view) {
          res.data.detailed_view.forEach((userData, i) => {
            newChartData.datasets.push({
              label: userData.email,
              lineTension: 0.2,
              borderWidth: 2,
              pointRadius: 2,
              backgroundColor: '#E2782F99',
              borderColor: '#E2782F99',
              pointBorderColor: '#E2782F99',
              pointBackgroundColor: '#E2782F99',
              borderDash: [(i + 1) * 2, i + 1],
              data: userData.data
            });
          });
        }
        this.chartdata = newChartData;
      }, () => {
        this.usage_grapph_loading = false;
      });
    },

    getResidentialUsageGraph() {
      this.residential_usage_grapph_loading = true;
      return this.$store.dispatch("dashboard/getResidentialUsageGraph").then((res) => {
        this.residential_usage_grapph_loading = false;
        const newChartData = Object.assign({}, this.residential_chartdata);
        newChartData.labels = res.data.labels;
        newChartData.datasets[0] = {
          label: 'MBs used',
          lineTension: 0.2,
          borderWidth: 2,
          pointRadius: 2,
          backgroundColor: '#FFFFFF00',
          borderColor: '#E2782F',
          pointBorderColor: '#E2782F',
          pointBackgroundColor: '#E2782F',
          data: res.data.data
        };
        if (res.data.detailed_view) {
          res.data.detailed_view.forEach((userData, i) => {
            newChartData.datasets.push({
              label: userData.email,
              lineTension: 0.2,
              borderWidth: 2,
              pointRadius: 2,
              backgroundColor: '#E2782F99',
              borderColor: '#E2782F99',
              pointBorderColor: '#E2782F99',
              pointBackgroundColor: '#E2782F99',
              borderDash: [(i + 1) * 2, i + 1],
              data: userData.data
            });
          });
        }
        this.residential_chartdata = newChartData;
      }, () => {
        this.residential_usage_grapph_loading = false;
      });
    },

    getDatacenterUsageGraph() {
      this.datacenter_usage_grapph_loading = true;
      return this.$store.dispatch("dashboard/getDatacenterUsageGraph").then((res) => {
        this.datacenter_usage_grapph_loading = false;
        const newChartData = Object.assign({}, this.datacenter_chartdata);
        newChartData.labels = res.data.labels;
        newChartData.datasets[0] = {
          label: 'MBs used',
          lineTension: 0.2,
          borderWidth: 2,
          pointRadius: 2,
          backgroundColor: '#FFFFFF00',
          borderColor: '#E2782F',
          pointBorderColor: '#E2782F',
          pointBackgroundColor: '#E2782F',
          data: res.data.data
        };
        if (res.data.detailed_view) {
          res.data.detailed_view.forEach((userData, i) => {
            newChartData.datasets.push({
              label: userData.email,
              lineTension: 0.2,
              borderWidth: 2,
              pointRadius: 2,
              backgroundColor: '#E2782F99',
              borderColor: '#E2782F99',
              pointBorderColor: '#E2782F99',
              pointBackgroundColor: '#E2782F99',
              borderDash: [(i + 1) * 2, i + 1],
              data: userData.data
            });
          });
        }
        this.datacenter_chartdata = newChartData;
      }, () => {
        this.datacenter_usage_grapph_loading = false;
      });
    },

    getCurrentSubscription() {
      return this.$store
          .dispatch("dashboard/getCurrentSubscription")
          .then((res) => {
            this.subscription = res.data.subscriptions[0];
          }, console.error);
    },

    getCurrentResidentialSubscription() {
      return this.$store
          .dispatch("dashboard/getCurrentResidentialSubscription")
          .then((res) => {
            this.residential_subscription = res;
          }, console.error);
    },

    getCurrentDatacenterSubscription() {
      return this.$store
          .dispatch("dashboard/getCurrentDatacenterSubscription")
          .then((res) => {
            this.datacenter_subscription = res;
          }, console.error);
    },

    getResidentialCredentials() {
      return this.$store
          .dispatch("dashboard/getResidentialCredentials")
          .then((res) => {
            this.residential_credentials = res;
          }, console.error);
    },

    getDatacenterCredentials() {
      return this.$store
          .dispatch("dashboard/getDatacenterCredentials")
          .then((res) => {
            this.datacenter_credentials = res;
          }, console.error);
    },

    getAPIRenewStatus() {
      return this.$store
          .dispatch("dashboard/getAPIRenewStatus")
          .then((res) => {
            this.api_renew_status = res.auto_prolong_web_scraping_api;
          }, console.error);
    },

    parseDate(date) {
      return getDateUTCString(new Date(date));
    },

    getUTCDateString(timestamp) {
      return getDateUTCString(new Date(timestamp * 1000));
    },

    reload() {
      this.$router.go();
    },
  },
  mounted() {
    this.loading = true;
    Promise.all([
      this.getToken(),
      this.getCurrentSubscription(),
      this.getCurrentResidentialSubscription(),
      this.getCurrentDatacenterSubscription(),
      this.getResidentialCredentials(),
      this.getDatacenterCredentials(),
      this.getAPIRenewStatus(),
    ]).then(
      () => (this.loading = false),
      () => (this.loading = false)
    );
    this.getUsageGraph();
    this.getResidentialUsageGraph();
    this.getDatacenterUsageGraph();
  },
};
</script>

<style scoped>
.md-card {
  margin: 15px;
}

.md-dialog-container {
  width: 50%;
  height: 75%;
}

pre[class*="language-"] {
  max-height: 30em;
  border-radius: 2px;
  background-color: #f7f7f7;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.execution-notice {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100px;
  width: 100%;
  height: 75%;
}

.execution-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 100px;
}
</style>
